export const PaymentModeEnum = new Map<number, 
{ label: string; }>([
  [1, { label: "Cash"}],
  [2, { label: "Online"}],
]);